import React from "react";
import { CheckBox } from "./Checkbox";
import { getFormattedDate } from "../../../../common/utils/methods/commonMethods/utilityMethod";
import { formattedPrice } from "../../utils";
import PaymentStatusChip from "./PaymentStatusChip";
import CustomTooltip from "../../../../common/customTooltip/CustomTooltip";
import styles from "./styles.module.scss";
import ItemDescription from "./ItemDescription";
const ChargesItemRow = ({
  row,
  checked,
  onChange,
  disable,
  isParent = false,
  showCancelsPaymentDetails,
  type,
  desc,
}) => {
  return (
    <>
      <div
        style={{
          position: "sticky",
          left: "0px",
          background: "white",
          borderRight: "1px solid #E2E2E2",
        }}
      >
        <CheckBox disabled={disable} isChecked={checked} handler={onChange} />
      </div>
      <div>
        <CustomTooltip title={row.description}>
          <div className="ellipsis-text-container">{row.description}</div>
        </CustomTooltip>
      </div>
      <div>{getFormattedDate(row.dueDate)}</div>
      <div>{row.term}</div>
      <div>{row.courseId}</div>
      <div>
        <CustomTooltip
          title={
            <ItemDescription
              type={type}
              desc = {desc}
              itemList={row.itemTypeList || [row.itemType]}
            />
          }
        >
          <div className="ellipsis-text-container">
            {row.itemTypeList?.toString() || row.itemType?.toString()}{" "}
          </div>
        </CustomTooltip>
      </div>
      <div className={styles["amount-cell"]}>
        {formattedPrice(row.totalGrossAmount)}
      </div>
      <div className={styles["amount-cell"]}>
        {formattedPrice(row.totalNetPayableAmount)}
      </div>
      <div className={styles["amount-cell"]}>
        {formattedPrice(row.totalPaidAmount)}
      </div>
      <div className={styles["amount-cell"]}>
        {formattedPrice(row.totalBalanceAmount)}
      </div>
      <div
        style={{
          position: "sticky",
          right: "0px",
          background: "white",
          borderLeft: "1px solid #E2E2E2",
          height: "100%",
        }}
      >
        <PaymentStatusChip status={row?.status} />
      </div>
      <div>
        {isParent && row?.failedChequeHistory && (
          <div
            onClick={() => showCancelsPaymentDetails(row)}
            className="error-info-dot-warning-sm cursor"
          >
            !
          </div>
        )}
      </div>
    </>
  );
};

export default ChargesItemRow;
